import {
	categoryPermissionChecker,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import type {ICategory} from '../schema';

export const canDownloadCategory = (category?: ICategory): boolean => {
	if (category == null) return false;
	return categoryPermissionChecker({
		category,
		permissionMatrixName: PermissionMatrixName.DOWNLOAD,
		permissionName: PermissionName.DOWNLOAD,
	});
};
